import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { DashboardAlert } from '@/types/dashboard';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type Response = DashboardAlert[];

const validate = () => {};

export const getDashboardAlerts = async (scope: RequestScope, options: ReadRequestOptions): Promise<EndpointResponse<Response>> => {
  try {
    validate();

    const result = await scopedApi(scope).get<EndpointResponse<Response>>('dashboard_alert', options);

    if (result.data.isError) {
      return result.data;
    }

    // Filter out disabled alerts
    const alerts = result.data.result || [];
    const enabledAlerts = alerts.filter((alert: DashboardAlert) => !alert.disabled);

    return {
      ...result.data,
      result: enabledAlerts,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
